import React, { useEffect } from 'react';
import { Box, Button } from 'lmc-ui-library';
import { SubPageTemplate } from '../../partials';
import { CreditCheckResult } from 'modules/cm/Credit/Credit';
import CreditForm from './CreditForm';
import CreditHistory from './CreditHistory';
import { Modal, Icon } from 'lmc-ui-library';
import { Header, ErrorItem, ErrorText, CreditHistoryWrapper } from './CreditComponent.styled';
import { Loader } from 'form/components/Select/Select.styled';
import { useDispatch } from 'react-redux';
import { saveCase } from 'modules/cm/store/cases/actions';
import useSaveButtonClicked from '../../hooks/useSaveButtonClicked';

interface Props {
  current?: CreditCheckResult;
  history: CreditCheckResult[];
  isLoading: boolean;
  error: string;
  onModalClose: () => void;
  onGenerateSoftCheck: () => Promise<void>;
}

const Credit: React.FC<Props> = ({ current, history = [], error, isLoading, onModalClose, onGenerateSoftCheck }) => {
  const dispatch = useDispatch();

  const handleGenerateNewSoftCheck = (e: React.MouseEvent<typeof Button>) => {
    onGenerateSoftCheck();
  };

  const { addListener, removeListener } = useSaveButtonClicked();
  useEffect(() => {
    const listener = addListener(() => {
      dispatch(saveCase());
    });
    return () => {
      removeListener(listener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SubPageTemplate title="">
      <Box>
        <Box.Content>
          <Header>Soft search</Header>
          <CreditForm checkResult={current} />
          <div style={{ width: '228px' }}>
            <Button type="button" mode="primary" onClick={handleGenerateNewSoftCheck} disabled={isLoading} width="100%">
              {isLoading ? <Loader style={{ margin: '0 auto' }} /> : 'Generate new soft search'}
            </Button>
          </div>
        </Box.Content>

        <CreditHistoryWrapper isLoading={isLoading}>
          <Header>Credit search history</Header>
          <CreditHistory history={history} />
        </CreditHistoryWrapper>
      </Box>
      <Modal showCloseBtn={false} isOpen={!!error}>
        <Modal.Header title="Error!" mode="error" />
        <Modal.Content>
          <ErrorItem>
            <Icon type="warning" color="#FA5245" />
            <ErrorText>{error}</ErrorText>
          </ErrorItem>
        </Modal.Content>
        <Modal.Footer style={{ display: 'grid' }}>
          <Button mode="ghost" borderVariant="rectangle" onClick={onModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </SubPageTemplate>
  );
};

export default Credit;
